import { cleanUseless, setInit } from './service'

export function initDict({ clean, ...useDictInit }) {
    setInit(useDictInit)

    if (clean?.interval !== 0) {
        setInterval(
            () => {
                cleanUseless(clean?.delay)
            },
            clean?.interval ?? 2 * 60 * 10_000,
        )
    }
    return {
        install() {
            // nothing
        },
    }
}
